import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { NetworkContext } from '../../context/NetworkContext';
import { DefaultTokenContext } from '../../context/DefaultTokenContext';
import { SetupContext } from '../../context/SetupContext';
import { SyncTx } from '../../context/types/NetworkTypes';

import { Spin } from 'antd';

import CustomButton from '../Componentization/CustomButton';
import CustomText from '../../styles/CustomText';
import CourierText from '../../styles/CourierText';
import CustomImageCard from '../Componentization/Card/CustomImageCard';

import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkHeaderText, checkSelectActiveTab, checkUnlock, checkUnlockPincode, RootState } from '../../store';
import useSecureStorage from '../../hooks/useSecureStorage';
import useWallet from '../../hooks/useWallet';
import useQwalletServer from '../../hooks/useQwalletServer';

import MainPageHeader from '../../nav/MainPageHeader';
import { tgShowAlert } from '../../utils/telegramPopup';
import { getTelegramId } from '../../utils/telegramClientData';

import moment from 'moment';
import { RefreshCw } from 'lucide-react';
import NavigationBar from '../../nav/NavigationBar';
import BigNumber from 'bignumber.js';
import i18next from 'i18next';

interface Asset {
    id: number
    name: string
    symbol: string
    balance: string
    icon: any
    address: string | null
    networkid: string
    chainid: string
    networkname: string
    useswap: boolean
}

interface Event {
    id: number;
    title: string;
    contents: string;
    bannerImageUrl: string;
    extUrl: string;
    appScreen: string;
    network: string;
    donationIdx: string;
    isActive: string;
}

interface Donation {
    id: number;
    code: string;
    title: string;
    imageUrl: string;
    extUrl: string;
    text: string;
    check: string;
    completeImageUrl: string;
    completeTitle: string;
    completeContents: string;
    is_active: string;
}

// 내부이체용 확장 타입
type ExtendedTx = SyncTx & {
    isInternal?: boolean;
    qPin?: number;
    shopName?: string;
};

let NETWORK_CURRENCY = process.env.REACT_APP_NETWORK_CURRENCY;

const BalanceScreen = () => {
    const { theme } = useContext(ThemeContext)
    const {
        balance,
        lastSyncTxs,
        getBalance,
        getTokenBalance,
        getServerTxHistory,
        startDbSyncTimer,
        stopDbSyncTimer
    } = useContext(NetworkContext)
    const {
        networkInfo,
        tokenInfo,
        userTokenInfo,
        getNetworkToken,
        searchNetwork,
        searchToken
    } = useContext(DefaultTokenContext);

    const {
        eventInfo,
        donationInfo,
        checkForceUpdateTxHistory,
        completeForceUpdateTxHistory
    } = useContext(SetupContext);

    let location = useLocation();
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const { t } = useTranslation();

    const pinCode = useSelector((state: RootState) => state.pincode.value);

    const {
        getWalletAddress,
        getBlockChain,
        getNetworkCurrency,
        getHideToken
    } = useSecureStorage()

    const {
        restoreWallet
    } = useWallet()

    const { resetServerTxHistory } = useQwalletServer()

    const [activeTab, setActiveTab] = useState(NETWORK_CURRENCY)

    const [defaultAssetsList, setDefaultAssetsList] = useState<Asset[]>([]);
    const [assets, setAssets] = useState<Asset[]>([]);
    const [hiddenTokens, setHiddenTokens] = useState<string[]>([]);
    const [events, setEvents] = useState<Event[]>([]);

    const [donationUI, setDonationUI] = useState<Donation[]>([]);
    const [initDefaultAsset, setInitDefaultAsset] = useState(false)
    const [initOtherDefaultAsset, setInitOtherDefaultAsset] = useState(false)
    const [isTxCheckModalOpen, seIsTxCheckModalOpen] = useState(false)
    const [isTxUpdateModalOpen, setIsTxUpdateModalOpen] = useState(false)
    const [lastTxList, setLastTxList] = useState<ExtendedTx[]>([])

    const [selectedNetwork, setSelectedNetwork] = useState<string>('');

    let isStopTxUpdate = false
    let limitTxCount = 0

    const lastSelectActiveTab = useSelector((state: RootState) => state.selectActiveTab.value)

    useEffect(() => {
        dispatch(checkHeaderText({ "link": "BalanceScreen", "title": t('template_balance_screen_message_01') }))
    }, [location])

    useEffect(() => {
        const initializeForceUpdate = async () => {
            checkTxUpdate().then(() => { })

            if (lastSelectActiveTab) {
                setActiveTab(lastSelectActiveTab)
            } else {
                const networkCurrency = await getNetworkCurrency()
                NETWORK_CURRENCY = networkCurrency
                setActiveTab(networkCurrency)

                console.log(`initializeForceUpdate networkCurrency 기본코인 설정`, networkCurrency)
            }
        };

        const initializeNetwork = async () => {
            const network = await getBlockChain();
            const selNetwork = await getBlockChain()
            const telegramId = await getTelegramId()
            const walletAddress = await getWalletAddress()

            if ('' === selNetwork) {
                console.warn(`fetchServerTxHistory 잘못된 네트워크 정보`)
                await tgShowAlert(t('balance_screen_message_05'))
                await moveUnLockPage()

                return
            } if ('' === telegramId) {
                console.warn(`fetchServerTxHistory 잘못된 텔레그램 유저 정보`)
                await tgShowAlert(t('balance_screen_message_10'))
                await moveUnLockPage()

                return
            } if (!walletAddress) {
                console.warn(`fetchServerTxHistory 지갑주소 정보 없음`)
                await tgShowAlert(t('balance_screen_message_12'))
                await moveUnLockPage()

                return
            } if (null == walletAddress || '' === walletAddress) {
                console.warn(`BalanceScreen initializeNetwork 지갑주소 정보 없음`)
                await moveUnLockPage()
                return
            }

            setSelectedNetwork(network);
        };

        initializeForceUpdate()
        initializeNetwork();
    }, []);

    const checkTxUpdate = async () => {
        const walletAddress = await getWalletAddress()
        const network = await getBlockChain()
        const tid = await getTelegramId()

        const isForceTxUpdateStart = await checkForceUpdateTxHistory(network)
        console.log(`BalanceScreen checkTxUpdate checkForceUpdateTxHistory 강제갱신 여부: ${isForceTxUpdateStart}`)

        if (true === isForceTxUpdateStart) {
            console.log(`BalanceScreen checkTxUpdate 전송내역 강제갱신 시작`)

            if (!walletAddress || !network || !tid) {
                console.error(`walletAddress network tid 값 오류로 전송내역 강제갱신 실행 중지. ${walletAddress} ${network} ${tid}`);
                return;
            }

            const result = await resetServerTxHistory(walletAddress, network, tid)
            if (true === result) {
                console.log(`BalanceScreen checkTxUpdate 전송내역 강제갱신 시작`)
                await stopDbSyncTimer()
                await startDbSyncTimer()
                await completeForceUpdateTxHistory(network)
                return;
            }
        }
    }

    const moveUnLockPage = () => {
        console.log(`BalanceScreen moveUnLockPage`)

        dispatch(checkUnlock(false))
        dispatch(checkUnlockPincode(''))

        setTimeout(() => {
            navigate(`/UnlockScreen`, { replace: true, state: {} });
        }, 100)
    }

    useEffect(() => {
        dispatch(checkSelectActiveTab(activeTab || ''))
        fetchServerTxHistory()
    }, [lastSyncTxs, activeTab])

    const fetchServerTxHistory = async () => {
        console.log(`WalletScreen fetchServerTxHistory 시작`)

        const walletAddress = await getWalletAddress()
        const selNetwork = await getBlockChain()
        const telegramId = await getTelegramId()

        if ('' === selNetwork) {
            console.warn(`fetchServerTxHistory 잘못된 네트워크 정보`)
            await tgShowAlert(t('balance_screen_message_05'))
            return
        }
        if ('' === telegramId) {
            console.warn(`fetchServerTxHistory 잘못된 텔레그램 유저 정보`)
            await tgShowAlert(t('balance_screen_message_10'))
            return
        }

        if (!walletAddress) {
            console.warn(`fetchServerTxHistory 지갑주소 정보 없음`)
            await tgShowAlert(t('balance_screen_message_12'))
            return
        }

        const setTab = activeTab || process.env.REACT_APP_NETWORK_CURRENCY!

        const selectTokenInfo = await searchToken(setTab)
        console.log(`WalletScreen fetchServerTxHistory selectTokenInfo : `, selectTokenInfo)

        let history = null
        let lastTxList: ExtendedTx[] = []
        if (selectTokenInfo?.type === 'coin') {
            history = await getServerTxHistory(walletAddress, selNetwork, telegramId, 'alltx', 1, 6)
            lastTxList = history.items
                .map((tx: any, index: number) => convertCoinLastTx(tx, walletAddress, setTab))
                .filter(Boolean) as ExtendedTx[];
        } else if (selectTokenInfo?.type === 'token') {
            history = await getServerTxHistory(walletAddress, selNetwork, telegramId, setTab, 1, 6)
            lastTxList = history.items
                .map((tx: any, index: number) => convertTokenLastTx(tx, walletAddress, setTab)) as ExtendedTx[];
        } else {

        }

        if (lastTxList.length > 0) {
            setLastTxList([])
            setLastTxList(lastTxList.slice(0, 6));
        } else {
            setLastTxList([])
        }
    }

    // 코인 전송내역 변환 + seller.qpin / seller.seller_name 매핑
    const convertCoinLastTx = (tx: any, accountAddress: string, symbol: string): ExtendedTx | null => {
        const txId = tx.transaction_hash;
        const fromAddress = tx.from.hash;
        const detailDate = moment(Number(tx.timestamp) * 1000).format('YYYY. M. D');
        const amount = tx.value;
        const fee = tx.fee.value;
        const transferType = tx.transfer_type;
        const coinType = tx.coin_type;

        // ✅ seller 객체에서 qpin / seller_name 추출
        const rawQPin = tx.seller?.qpin ?? null;
        const rawShopName = tx.seller?.seller_name ?? null;

        symbol = symbol.substring(0, 4);

        console.log(`convertCoinLastTx tx : `, tx)

        let txData: ExtendedTx | null = null;
        if (coinType === 'coin') {
            if (amount > 0 && transferType === 'withdrawal') {
                txData = {
                    id: `${txId}`,
                    type: fromAddress === accountAddress
                        ? t('template_wallet_screen_message_09')
                        : t('template_wallet_screen_message_10'),
                    amount: (Number(amount) + Number(fee)).toString(),
                    currency: symbol.toLocaleUpperCase(),
                    date: detailDate,
                    direction: transferType.toLowerCase() === 'withdrawal' ? 'out' : 'in'
                };
            } else if (amount > 0 && transferType === 'receive') {
                txData = {
                    id: `${txId}`,
                    type: fromAddress === accountAddress
                        ? t('template_wallet_screen_message_09')
                        : t('template_wallet_screen_message_10'),
                    amount: amount,
                    currency: symbol.toLocaleUpperCase(),
                    date: detailDate,
                    direction: transferType.toLowerCase() === 'withdrawal' ? 'out' : 'in'
                };
            } else {
                txData = {
                    id: `${txId}`,
                    type: fromAddress === accountAddress
                        ? t('template_wallet_screen_message_09')
                        : t('template_wallet_screen_message_10'),
                    amount: fee,
                    currency: symbol.toLocaleUpperCase(),
                    date: detailDate,
                    direction: transferType.toLowerCase() === 'withdrawal' ? 'out' : 'in'
                };
            }
        } else if (coinType === 'token' && transferType.toLowerCase() === 'withdrawal' && 0 < fee) {
            txData = {
                id: `${txId}`,
                type: fromAddress === accountAddress
                    ? t('template_wallet_screen_message_09')
                    : t('template_wallet_screen_message_10'),
                amount: fee,
                currency: symbol.toLocaleUpperCase(),
                date: detailDate,
                direction: transferType.toLowerCase() === 'withdrawal' ? 'out' : 'in'
            };
        }

        // ✅ seller 정보가 있으면 내부이체 메타데이터로 세팅
        if (txData && (rawQPin != null || rawShopName)) {
            txData.isInternal = true;
            if (rawQPin !== null && rawQPin !== undefined && rawQPin !== '') {
                const qNum = Number(rawQPin);
                if (!Number.isNaN(qNum)) {
                    txData.qPin = qNum;
                }
            }
            if (rawShopName) {
                txData.shopName = String(rawShopName);
            }
        }

        return txData;
    }

    // 토큰 전송내역 변환 + seller.qpin / seller.seller_name 매핑
    const convertTokenLastTx = (tx: any, accountAddress: string, symbol: string): ExtendedTx => {
        const txId = tx.transaction_hash;
        const fromAddress = tx.from.hash;
        const detailDate = moment(Number(tx.timestamp) * 1000).format('YYYY. M. D');
        const amount = tx.value;
        const transferType = tx.transfer_type;

        // ✅ seller 객체에서 qpin / seller_name 추출
        const rawQPin = tx.seller?.qpin ?? null;
        const rawShopName = tx.seller?.seller_name ?? null;

        symbol = symbol.substring(0, 4);

        const txData: ExtendedTx = {
            id: `${txId}`,
            type: fromAddress === accountAddress
                ? t('template_wallet_screen_message_09')
                : t('template_wallet_screen_message_10'),
            amount: amount,
            currency: symbol.toLocaleUpperCase(),
            date: detailDate,
            direction: transferType.toLowerCase() === 'withdrawal' ? 'out' : 'in'
        }

        if (rawQPin != null || rawShopName) {
            txData.isInternal = true;
            if (rawQPin !== null && rawQPin !== undefined && rawQPin !== '') {
                const qNum = Number(rawQPin);
                if (!Number.isNaN(qNum)) {
                    txData.qPin = qNum;
                }
            }
            if (rawShopName) {
                txData.shopName = String(rawShopName);
            }
        }

        return txData;
    }

    useEffect(() => {
        const initializeAssets = async () => {
            console.log(`1 initializeAssets tokenInfo`, tokenInfo)

            if (0 >= tokenInfo.length) {
                console.log(`tokenInfo is empty`)
                return
            }

            const network = await getBlockChain()
            const networkToken = await getNetworkToken(network)

            const hidden = await getHideToken(network.toLowerCase());
            setHiddenTokens(hidden.map((tokenName: string) => tokenName.toLowerCase()));

            const defaultAssets = networkToken.map((token, index) => ({
                id: index,
                name: token.name,
                symbol: token.symbol,
                balance: '0.000000',
                icon: token.icon,
                address: token.contract,
                networkid: token.networkid,
                chainid: token.chainid,
                networkname: token.networkname,
                useswap: token.useswap,
            }));
            console.log(`2 defaultAssets`, defaultAssets)

            const defaultLength = defaultAssets.length || 1
            const userAssets = userTokenInfo.map((token, index) => ({
                id: index + defaultLength + 1,
                name: token.name,
                symbol: token.symbol,
                balance: '0.000000',
                icon: token.icon,
                address: token.contract,
                networkid: token.networkid,
                chainid: token.chainid,
                networkname: token.networkname,
                useswap: token.useswap,
            }));
            console.log(`3 userAssets`, userAssets)

            setDefaultAssetsList([
                ...defaultAssets,
                ...userAssets
            ]);

            console.log(`4 initializeAssets defaultAssets`, defaultAssets)

            setInitDefaultAsset(true)
        };

        initializeAssets();

    }, [tokenInfo]);

    useEffect(() => {
        const initializeEvents = async () => {
            let defaultEvents = null

            defaultEvents = await eventInfo.map((event, index) => ({
                id: event.idx,
                title: event.title_en,
                contents: event.contents_en,
                bannerImageUrl: event.banner_image_en_url,
                extUrl: event.ext_url,
                appScreen: event.app_screen,
                network: event.network,
                donationIdx: event.donation_idx,
                isActive: event.is_active
            })
            );

            if (defaultEvents.length > 0) {
                const selNetwork = await getBlockChain();
                defaultEvents = defaultEvents.filter(event => event.network === null || event.network === 'all' || event.network === selNetwork);
            }

            setEvents(defaultEvents);
        };

        initializeEvents();
    }, [eventInfo, donationInfo]);

    useEffect(() => {
        const fetchTokenBalance = async () => {
            const walletAddress = await getWalletAddress()

            if (null == walletAddress || '' === walletAddress) {
                console.warn(`fetchTokenBalance 지갑주소 정보 없음`)
                return
            }

            if (true === initDefaultAsset) {
                const value = await getBalance(walletAddress, true, 'promise')
                defaultAssetsList[0].balance = parseFloat(value.toString()).toFixed(10)

                const updatedAssets = await Promise.all(
                    defaultAssetsList.slice(1).map(async (asset, index) => {
                        if (asset.address) {
                            const balance = await getTokenBalance(walletAddress, asset.address, true, 'promise')

                            return {
                                ...asset,
                                balance: parseFloat(balance.toString()).toFixed(10),
                                icon: asset.icon
                            }
                        }
                        return asset
                    })
                )

                const newDefaultAssetsList = [
                    defaultAssetsList[0],
                    ...updatedAssets
                ]

                setAssets(newDefaultAssetsList);

                setInitDefaultAsset(false)
            }
        }

        fetchTokenBalance()

    }, [initDefaultAsset])


    useEffect(() => {
        timerTokenBalance();
        const intervalId = setInterval(() => {
            console.log(`timerTokenBalance 호출`)
            timerTokenBalance();
        }, 2000);

        return () => clearInterval(intervalId);
    }, [defaultAssetsList]);


    const timerTokenBalance = async () => {
        const walletAddress = await getWalletAddress()

        console.log(`1 timerTokenBalance`)
        if (null == walletAddress || '' === walletAddress) {
            console.warn(`timerTokenBalance 지갑주소 정보 없음`)
            return
        }

        console.log(`2 timerTokenBalance defaultAssetsList: `, defaultAssetsList)

        if (defaultAssetsList.length > 0) {
            console.log(`3 timerTokenBalance`)

            let coinBalance = await getBalance(walletAddress, true, 'cache')
            if (!coinBalance) {
                console.warn(`캐시에서 coinbalance 키를 찾을 수 없습니다.`);
                coinBalance = 0;
            }

            defaultAssetsList[0].balance = coinBalance.toString()

            const updatedAssets = await Promise.all(
                defaultAssetsList.slice(1).map(async (asset, index) => {
                    if (asset.address) {
                        const balance = await getTokenBalance(walletAddress, asset.address, true, 'cache')

                        return {
                            ...asset,
                            balance: parseFloat(balance).toFixed(10),
                            icon: asset.icon
                        }
                    }
                    return asset
                })
            )

            const newDefaultAssetsList = [
                defaultAssetsList[0],
                ...updatedAssets
            ]

            setAssets(newDefaultAssetsList);
        }
    }

    const syncFormatNumberWithCommas = (
        input: BigNumber,
        decimalPlaces: number = 3
    ): string => {
        if (input === null || input.isNaN()) {
            return "0." + "0".repeat(decimalPlaces);
        }

        const absInput = input.abs();

        const units = [
            { value: new BigNumber(1e12), symbol: "T" },
            { value: new BigNumber(1e9), symbol: "B" },
            { value: new BigNumber(1e6), symbol: "M" }
        ];

        const unit = units.find(u => absInput.isGreaterThanOrEqualTo(u.value));
        if (unit) {
            const scaled = absInput.dividedBy(unit.value);
            const decimals = 2;
            const scale2 = new BigNumber(10).pow(decimals);
            const truncated = scaled.multipliedBy(scale2).integerValue(BigNumber.ROUND_FLOOR).dividedBy(scale2);
            const formatted = truncated.toFixed(decimals);
            return formatted + unit.symbol;
        }

        const integerPart = absInput.integerValue(BigNumber.ROUND_FLOOR);
        const integerStr = integerPart.toString();
        let effectiveDecimals = decimalPlaces;
        if (integerStr.length > 4) {
            effectiveDecimals = Math.max(0, decimalPlaces - (integerStr.length - 4));
        }

        const scale = new BigNumber(10).pow(effectiveDecimals);
        const floored = absInput.multipliedBy(scale).integerValue(BigNumber.ROUND_FLOOR).dividedBy(scale);
        const fixedStr = floored.toFixed(effectiveDecimals).replace(/\.?0+$/, '');

        let [intPart, decPart] = fixedStr.split(".");
        intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return intPart + (decPart ? "." + decPart : "");
    };

    const getCurrentAsset = () => {
        return assets.find(asset => asset && asset.symbol && asset.symbol.toLowerCase() === activeTab)
    }

    const currentAsset = getCurrentAsset()
    const currentBalance = parseFloat(currentAsset?.balance || '0')
    const currentIcon = currentAsset?.icon || "./img/icon_none.png"

    const displayedTxList: ExtendedTx[] = lastTxList;

    const moveScreen = (screen: string, assetData: any) => {
        console.log(`moveScreen : `, screen, assetData)
        if (assetData !== null && assetData !== undefined && assetData !== '') {
            navigate(`${screen}`, { state: { token: assetData } })
        } else {
            console.warn('토큰 정보가 없습니다')
        }
    }

    const renderLoadinig = () => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Spin size="large" />
        </div>
    )

    const styles = {
        container: {
            paddingBottom: "70px"
        } as React.CSSProperties,
        cardContainer: {
            backgroundColor: theme.background_02,
            borderRadius: 12,
            padding: 16,
            marginBottom: 15
        } as React.CSSProperties,
        totalBalanceCard: {
            display: "flex",
            alignItems: 'center',
            marginBottom: 5
        } as React.CSSProperties,
        iconContainer: {
            width: 35,
            height: 35,
            borderRadius: 25,
            backgroundColor: theme.img_background_01,
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 15
        } as React.CSSProperties,
        balanceIcon: {
            width: 38,
            height: 38
        } as React.CSSProperties,
        balanceInfo: {
            display: "flex",
            flexDirection: 'column'
        } as React.CSSProperties,
        balanceRow: {
            display: "flex",
            alignItems: 'center',
        } as React.CSSProperties,
        balanceRowPressable: {
            display: "flex",
            alignItems: 'center',
        } as React.CSSProperties,
        balanceText: {
            fontSize: 26,
            color: theme.text_01,
            height: 28,
            cursor: "pointer"
        } as React.CSSProperties,
        balanceSubText: {
            fontSize: 14,
            color: theme.text_02,
        } as React.CSSProperties,
        arrowIcon: {
            width: 10,
            height: 16,
            marginLeft: 8,
        } as React.CSSProperties,
        sectionTitle: {
            fontSize: 15,
            color: theme.text_04,
            marginBottom: 16,
            marginTop: 25
        } as React.CSSProperties,
        networkSelectContainer: {
            display: "flex",
            width: "100%",
            marginBottom: 20,
            borderRadius: 10,
            justifyContent: 'center',
            alignItems: 'center',
        } as React.CSSProperties,
        tabContainer: {
            display: "flex",
            marginBottom: 20,
            borderRadius: 10,
            justifyContent: 'flex-start',
        } as React.CSSProperties,
        tabButton: {
            marginRight: 20,
            position: 'relative',
            paddingBottom: '8px'
        } as React.CSSProperties,
        tabText: {
            color: theme.text_03,
            fontSize: 16,
            marginTop: 4,
            cursor: "pointer",
            position: 'relative',
        } as React.CSSProperties,
        tabText2: {
            color: theme.text_03,
            fontSize: 20,
            cursor: "pointer",
            position: 'relative',
        } as React.CSSProperties,
        activeTabText: {
            color: theme.text_01
        } as React.CSSProperties,
        buttonRow: {
            display: "flex",
            marginTop: 20,
            gap: 11,
            width: "100%"
        } as React.CSSProperties,
        buttonLeftRowContainer: {
            display: "flex",
            backgroundColor: theme.button_01,
            borderRadius: 10,
            height: 42,
            width: "100%"
        } as React.CSSProperties,
        buttonRightRowContainer: {
            backgroundColor: theme.button_01,
            borderRadius: 10,
            height: 42,
            width: "30%"
        } as React.CSSProperties,
        buttonStyle: {
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
            background: "inherit"
        } as React.CSSProperties,
        sendButtonStyle: {
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
            padding: "10px 10px",
            width: "50%"
        } as React.CSSProperties,
        receiveButtonStyle: {
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
            padding: "10px 10px",
            width: "50%"
        } as React.CSSProperties,
        swapButtonStyle: {
            borderRadius: 10,
            padding: "10px 10px"
        } as React.CSSProperties,
        divider: {
            width: 1,
            backgroundColor: theme.divider_background_01
        } as React.CSSProperties,
        buttonTextStyle: {
            fontSize: 14,
            color: theme.text_01
        } as React.CSSProperties,
        otherChainStyle: {
            color: theme.text_01,
            fontSize: 18
        } as React.CSSProperties,
        otherChainUnitStyle: {
            color: theme.text_01,
            fontSize: 15
        } as React.CSSProperties,
        scrollView: {
            display: "flex",
        } as React.CSSProperties,
        scrollContent: {
            display: 'inline-flex',
        } as React.CSSProperties,
        transactionItem: {
            display: "flex",
            alignItems: 'center',
            padding: "8px 15px",
            backgroundColor: theme.card_background_04,
            borderRadius: 10,
            marginBottom: 10,
            border: `1px solid ${theme.border_04}`,
            width: "100%",
            boxSizing: "border-box",
            justifyContent: "space-between",
        } as React.CSSProperties,
        transactionIcon: {
            width: 24,
            height: 24,
            marginRight: 10
        } as React.CSSProperties,
        transactionName: {
            fontSize: 14,
            paddingTop: "3px"
        } as React.CSSProperties,
        transactionSubInfo: {
            fontSize: 12,
            color: theme.text_10,
            marginTop: 2
        } as React.CSSProperties,
        transactionAmountContainer: {
            display: "flex",
            alignItems: 'center'
        } as React.CSSProperties,
        transactionAmount: {
            fontSize: 16
        } as React.CSSProperties,
        transactionSymbol: {
            color: theme.text_06,
            fontSize: 12,
            marginLeft: 5,
            width: 40,
            textAlign: 'right',
            display: 'inline-block'
        } as React.CSSProperties,
        transactionDate: {
            fontSize: 14,
            color: theme.text_10,
            marginBottom: 15
        } as React.CSSProperties,
        activeTabUnderline: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '2px',
            backgroundColor: theme.text_01
        } as React.CSSProperties,
    }

    return (
        <>
            <MainPageHeader />
            <NavigationBar />
            <div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
                <div style={{ width: "100%" }}>
                    <div style={styles.tabContainer}>
                        {/* 기본 네트워크 탭 */}
                        <div
                            style={styles.tabButton}
                            onClick={() => setActiveTab(NETWORK_CURRENCY)}
                        >
                            <CustomText
                                weight="bold"
                                style={{
                                    ...styles.tabText2,
                                    color: activeTab === NETWORK_CURRENCY ? theme.text_01 : theme.text_02
                                }}
                            >
                                {NETWORK_CURRENCY?.toUpperCase()}
                            </CustomText>
                            {activeTab === NETWORK_CURRENCY && <div style={styles.activeTabUnderline} />}
                        </div>

                        {/* 가로 스크롤 토큰 탭 */}
                        <div style={styles.scrollView}>
                            <div style={styles.scrollContent}>
                                {defaultAssetsList.slice(1)
                                    .filter(item => !hiddenTokens.includes(item.name.toLowerCase()))
                                    .map(item => (
                                        <div
                                            key={item.id}
                                            style={styles.tabButton}
                                            onClick={() => setActiveTab(item.symbol)}
                                        >
                                            <CustomText
                                                weight="bold"
                                                style={{
                                                    ...styles.tabText,
                                                    color:
                                                        activeTab === item.symbol
                                                            ? theme.text_01
                                                            : theme.text_02
                                                }}
                                            >
                                                {item.name?.toUpperCase() || ''}
                                            </CustomText>
                                            {activeTab === item.symbol && <div style={styles.activeTabUnderline} />}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>

                    {/* 잔액 카드 */}
                    <div style={styles.cardContainer}>
                        <div style={styles.totalBalanceCard}>
                            <div style={styles.iconContainer}>
                                <img src={currentIcon} alt="Icon" style={styles.balanceIcon} />
                            </div>
                            <div style={styles.balanceInfo}>
                                <div style={styles.balanceRow}>
                                    <div
                                        style={styles.balanceRowPressable}
                                        onClick={() =>
                                            moveScreen('/WalletScreen', currentAsset)
                                        }
                                    >
                                        {initDefaultAsset ? (
                                            <RefreshCw
                                                color={theme.text_01}
                                                size={16}
                                                className='rotating-icon-repeat'
                                            />
                                        ) : (
                                            <CourierText weight="bold" style={styles.balanceText}>
                                                {syncFormatNumberWithCommas(new BigNumber(currentBalance.toString()), 3)}
                                            </CourierText>
                                        )}
                                        <img src="./img/icon_arrow_right.png" alt="Arrow Icon" style={styles.arrowIcon} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 송금/받기 버튼 */}
                        <div style={styles.buttonRow}>
                            <div style={styles.buttonLeftRowContainer}>
                                <CustomButton
                                    text={t('template_balance_screen_message_02')}
                                    textStyle={{ ...styles.buttonTextStyle, width: "auto" }}
                                    iconImage="./img/out_icon.png"
                                    iconSize={15}
                                    imageStyle={{ width: 24, height: 24 }}
                                    onPress={() => {
                                        const selectedToken = assets.find(asset => asset.symbol === activeTab);
                                        const currentBalance = selectedToken?.balance || '0.000000';
                                        const updatedToken = { ...selectedToken, balance: currentBalance };
                                        moveScreen('/WithdrawScreen', updatedToken)
                                    }}
                                    containerStyle={{ ...styles.buttonStyle, ...styles.sendButtonStyle }}
                                />
                                <div style={styles.divider} />
                                <CustomButton
                                    text={t('template_balance_screen_message_03')}
                                    textStyle={{ ...styles.buttonTextStyle, width: "auto" }}
                                    iconImage="./img/in_icon.png"
                                    iconSize={15}
                                    imageStyle={{ width: 24, height: 24 }}
                                    onPress={() =>
                                        moveScreen('/ReceiveScreen', currentAsset)
                                    }
                                    containerStyle={{ ...styles.buttonStyle, ...styles.receiveButtonStyle }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* 최근 거래내역 */}
                    <CustomText weight="bold" style={{ ...styles.sectionTitle, color: theme.label_strong, marginTop: '25px' }}>
                        {t('template_balance_screen_message_13')}
                    </CustomText>

                    {displayedTxList.length === 0 ? (
                        <CustomText style={{ color: theme.text_03, textAlign: 'center', width: '100%', padding: '40px 0 80px' }}>
                            {t('balance_screen_message_13')}
                        </CustomText>
                    ) : (
                        displayedTxList.map((item) => {
                            // seller 정보가 있으면 내부이체로 간주
                            const isInternal = !!item.isInternal || item.qPin != null || !!item.shopName;

                            return (
                                <div
                                    key={item.id}
                                    style={{ ...styles.transactionItem, backgroundColor: theme.card_background_06 }}
                                    onClick={() => {
                                        moveScreen('/WalletScreen', currentAsset)
                                    }}
                                >
                                    {/* 좌측: 시간 / 내부이체 정보 */}
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <img
                                            src={item.direction === 'in' ? './img/in_icon.png' : './img/out_icon.png'}
                                            alt={item.direction === 'in' ? 'in transaction' : 'out transaction'}
                                            style={styles.transactionIcon}
                                        />
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <CustomText style={{ ...styles.transactionName, color: theme.label_strong }}>
                                                {item.date}
                                            </CustomText>
                                            {isInternal && (
                                                <CustomText style={styles.transactionSubInfo}>
                                                    {`[${item.qPin ?? ''}]${item.shopName ?? ''}`}
                                                </CustomText>
                                            )}
                                        </div>
                                    </div>

                                    {/* 우측: 금액 + 단위 */}
                                    <div style={styles.transactionAmountContainer}>
                                        <CourierText
                                            weight="bold"
                                            style={{
                                                ...styles.transactionAmount,
                                                color: item.direction === 'in' ? theme.text_18 : theme.text_07
                                            }}
                                        >
                                            {Number(item.amount) !== 0 ? (item.direction === 'in' ? '+' : '-') : ''}
                                            {syncFormatNumberWithCommas(new BigNumber(item.amount.toString()), 10)}
                                            {/* {syncFormatNumberWithCommas(new BigNumber(item.amount.toString()), 3)} */}
                                        </CourierText>
                                        <CustomText style={styles.transactionSymbol}>
                                            {item.currency}
                                        </CustomText>
                                    </div>
                                </div>
                            );
                        })
                    )}

                </div>
            </div>
        </>
    )
}

export default BalanceScreen
